import React, { ButtonHTMLAttributes, forwardRef } from "react";
import "./Button.scss";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost" | "outline";
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
}

// 호출부가 실제 `<button>` 에 접근할 수 있어야 한다 — 포커스 복구처럼 DOM 노드가 필요한
// 동작을 래퍼가 가로막으면 안 된다. `ref` 를 넘기지 않는 기존 사용처는 영향이 없다.
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ variant = "primary", size = "md", children, className = "", ...props }, ref) => {
  return (
    <button ref={ref} className={`btn btn--${variant} btn--${size} ${className}`} {...props}>
      {children}
    </button>
  );
});
Button.displayName = "Button";

export default Button;
